import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
// 导入所有图标并进行全局注册
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import 'element-plus/es/components/message/style/css'
// 引入字体的文件
import './assets/font/iconfont.css'
// 引入全局的样式文件
import './assets/css/global.less'
// import Axios from 'axios'
// import { get, post, del, put } from './utils/http'
import http from '@/utils/http'
import Apis from '@/utils/apis'
import Storage from '@/utils/storage'
import Fun from '@/utils/method_utils'
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(ElementPlus, {
  locale: zhCn
})
// 导入所有图标并进行全局注册
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.config.globalProperties.$tinymce = tinymce
app.use(VueTinymce)

// 请求基准路径的配置
// Axios.defaults.baseURL = 'http://201.200.200.236:8002'
// 挂载全局方法 将axios挂载到Vue的原型对象上
app.config.globalProperties.$http = http
// 将全局的echarts对象挂载到Vue的原型对象上
// 在别的组件中将可以this.$echarts使用
// app.config.globalProperties.$echarts = window.echarts
app.config.globalProperties.$api = Apis
// app.config.globalProperties.$wxApi = WXApi
app.config.globalProperties.$storage = Storage
app.config.globalProperties.$fun = Fun
app.mount('#app')
